"use strict";
/*jshint esversion: 11 */

import React, { useEffect } from "react";

export default function CsfMembreDispenseConfirmationModal() {

  useEffect(() => {
    // reloader la page à la fermeture de la modale de confirmation
    const handler = () => window.location.reload();
    $('#membreDispenseConfirmationModal').on('hidden.bs.modal', handler);

    return () => {
      // nettoyage au unmout du composant
      $('#membreDispenseConfirmationModal').off('hidden.bs.modal', handler);
    };
  }, []);


  return (
    <div className="modal fade" id="membreDispenseConfirmationModal" tabIndex="-1" role="dialog" aria-labelledby="membreDispenseConfirmationModalTitle"
      aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h2 id="membreDispenseModalConfirmationTitle">{window.Drupal.t('membre.dispense.modal.title')}</h2>
            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            <p className="text-center larger-text mt-4" dangerouslySetInnerHTML={{__html: window.Drupal.t('membre.dispense.modal.confirmation')}}></p>
          </div>

          <div className="modal-footer">
              <div className="space-between-wrapper">
                <button type="button" className='button btn-pale btn-larger' data-dismiss="modal">{window.Drupal.t('fournisseur.back.btn')}</button>
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

